import { DELETE, POST } from "src/helpers/api/request";

export const loginService = data => {
  return POST(`/login`, data);
};
export const logoutService = () => {
  return DELETE(`sso/bo/logout`);
};
